// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.messageFooter[data-v-059ed0c7] {\n  width: 100%;\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: right;\n      -ms-flex-pack: right;\n          justify-content: right;\n  padding: 10px;\n  bottom: 1px;\n  border-top: 1px solid #cccccc;\n}\n[data-v-059ed0c7] .el-form-item--small.el-form-item {\n  margin-bottom: 10px !important;\n}\n", ""]);
// Exports
module.exports = exports;
